import { cipVersionEnum } from "../AppConfig";
import { ROUTES } from "../config/routes";
import { defaultHomeData, KEYS } from "../pages/home/defaultHomeData";

export const COUNTRY_CODE_API = "https://restcountries.com/v3.1/all?fields=name,idd"

export function cloneDeepArrWithObj(passedArray) {
  return passedArray.map((ele) => { return { ...ele } })
};



// Util function, will get removed in production when API's are integrated
export function getRandomElementFromArray(arr = []) {
  return arr[Math.floor(Math.random() * arr.length)]
}

//Util function to convert column text, (remove spaces, put an underscore and converts into a lowercase value)
export function getColumnField(str = "") {
  let strKey = str.replace(/\s_\s+/g, ' ');
  strKey = strKey.replaceAll(' ', '_')
  return strKey
}


// function to convert file object into base64 URL
export const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
})

// function to convert file base64 URL into object 
export const urlToFile = (url, filename, mimeType) => {
  return (fetch(url)
    .then(function (res) { return res.arrayBuffer(); })
    .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
  );
}

export const urlToArrayBuffer = (url) => {
  return (fetch(url)
    .then(function (res) { return res.arrayBuffer(); })
    // .then(function(buf){return buf})
  );
}

export const invertObj = obj => Object.fromEntries(Object.entries(obj).map(a => a.reverse()))

export const objIsEmpty = (obj) => {
  for (let _ in obj) return false;
  return true;
}

let f = (a, b) => [].concat(...a.map(a => b.map(b => [].concat(a, b))));
export let cartesian = (a, b, ...c) => b ? cartesian(f(a, b), ...c) : a;



let formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});
export function convertToUSDCurrencyFormat(value) {
  return formatter.format(value)
}


export function mutateOurCapabilitiesLinkBasedOnVersion(homePageData = defaultHomeData, version) {
  const baseOurCapabilitiesRoute = ROUTES.CIP_V2.OUR_CAPABILITIES.getOurCapabilitiesSlidePath()
  return homePageData.map(element => {
    if (element.id === KEYS.SERVICES && version === cipVersionEnum[1]) {
      return { ...element, link: baseOurCapabilitiesRoute }
    }
    return element
  })

}


export const verifyUserId = async (userId, dispatch, navigate, verifyUser, dispatchFn, clientIndex) => {
  const verifyUserPayload = {
    userId,
    clientIndex
  }
  try {
    const serverResponse = await verifyUser(verifyUserPayload).unwrap()
    if (!serverResponse) {
      navigate(ROUTES.LOGIN);
      return
    }
    dispatch(dispatchFn(serverResponse))
    return serverResponse
  } catch (err) {
    navigate(ROUTES.LOGIN)
  }
}


export const phoneCodes = (listOfPhoneCodes = null) => {
  let phoneCodes = [];
  listOfPhoneCodes?.forEach(phoneCode => {
    const { idd: { root, suffixes } } = phoneCode;
    suffixes.map((el) => {
      let code = root + el

      if (code !== 'undefined') {
        phoneCodes.push({ code })
      }

    })
  })
  return phoneCodes.sort((a, b) => a.code - b.code);
}



export const getUpperLowerBound = (boundaries, value) => {
  const allLower = boundaries?.filter(x => x <= value) ?? [];
  const allUpper = boundaries?.filter(x => x >= value) ?? [];

  const lowerBound = Math.max(...allLower);
  const upperBound = Math.min(...allUpper);

  return { lowerBound, upperBound }

}